import { Directive, ElementRef, forwardRef, HostListener, inject, input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
	selector: 'input[inputValidator]',
	standalone: true,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => InputValidatorDirective),
			multi: true,
		},
	],
	host: {
		class: '',
	},
})
export class InputValidatorDirective<INPUT_TYPE> implements ControlValueAccessor {
	private readonly elementRef: ElementRef<HTMLInputElement> = inject(ElementRef);
	public readonly $inputValidator = input.required<(value: string | INPUT_TYPE) => INPUT_TYPE>({
		alias: 'inputValidator',
	});

	private onChange: (change: INPUT_TYPE) => void = () => {};

	public writeValue(value: INPUT_TYPE): void {
		this.setValueToInput(value);
	}

	public registerOnChange(fn: (value: INPUT_TYPE) => void): void {
		this.onChange = fn;
	}

	public registerOnTouched(): void {}

	public setDisabledState(): void {}

	@HostListener('input')
	protected onInput(): void {
		this.setValueToInput(this.elementRef.nativeElement.value);
	}

	private setValueToInput(value: string | INPUT_TYPE): void {
		const validator = this.$inputValidator();
		const clean = validator(value);
		this.elementRef.nativeElement.value = `${clean}`;
		this.onChange(clean);
	}
}
